import ShoeCard from './ShoeCard'

export default ShoeCard
